"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UITooltipContent;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

function UITooltipContent(_ref) {
  var className = _ref.className,
      children = _ref.children;
  return _react.default.createElement("div", {
    className: (0, _classnames.default)('private-tooltip__inner', className),
    role: "tooltip"
  }, children);
}

UITooltipContent.propTypes = {
  children: _propTypes.default.node
};
UITooltipContent.displayName = 'UITooltipContent';
module.exports = exports.default;